module.exports = __webpack_public_path__ + "img/SoftwareCopyright_5.fd764692.png";